import React, { useState, useEffect, useMemo } from 'react';
import {Pagination as ReactPagination} from 'react-bootstrap'
import _ from 'lodash'
import teethImage from '../../_metronic/assets/teeth.jpeg'
import primaryTeethImage from '../../_metronic/assets/teeth2.jpg'

const permamentTeethMapper = {
  18: {
    coors: "1,4,44,188",
    D: ["8,92", "9,134"],
    M: ["40,134", "40,92"],
    O: "24,135",
    B: "25,87",
    Pa: "25,154",
    position: "23,74"
  },
  17: {
    coors: "46,7,89,191",
    D: ["54,92", "56,137"],
    M: ["84,91", "84,137"],
    O: "69,137",
    B: "67,87",
    Pa: "70,157",
    position: "67,71"
  },
  16: {
    coors: "94,15,138,189",
    D: ["99,92", "99,137"],
    M: ["133,91", "133,137"],
    O: "115,137",
    B: "114,87",
    Pa: "115,157",
    position: "115,70"
  },
  15: {
    coors: "141,14,172,190",
    D: ["145,92", "145,134"],
    M: ["167,92", "167,134"],
    O: "156,136",
    B: "157,87",
    Pa: "157,152",
    position: "157,74"
  },
  14: {
    coors: "174,13,205,190",
    D: ["180,92", "178,134"],
    M: ["199,92", "199,134"],
    O: "189,136",
    B: "189,90",
    Pa: "188,151",
    position: "190,72"
  },
  13: {
    coors: "207,11,236,190",
    D: ["211,90", "210,132"],
    M: ["234,90", "233,132"],
    I: ["222,106","222,115"],
    B: "222,90",
    Pa: "222,138",
    position: "223,70"
  },
  12: {
    coors: "238,11,271,191",
    D: ["246,93", "245,128"],
    M: ["263,93", "261,131"],
    I: ["254,106","254,116"],
    B: "254,93",
    Pa: "254,135",
    position: "255,68"
  },
  11: {
    coors: "273,11,304,190",
    D: ["277,93", "277,128"],
    M: ["299,93", "299,128"],
    I: ["289,106","289,116"],
    B: "289,93",
    Pa: "289,131",
    position: "289,65"
  },
  21: {
    coors: "306,10,340,191",
    D: ["333,93", "333,128"],
    M: ["310,93", "310,128"],
    I: ["320,105","320,116"],
    B: "320,93",
    Pa: "320,131",
    position: "320,65"
  },
  22: {
    coors: "343,10,371,191",
    D: ["364,93", "365,128"],
    M: ["346,93", "347,128"],
    I: ["354,105","354,116"],
    B: "354,93",
    Pa: "356,131",
    position: "354,72"
  },
  23: {
    coors: "372,10,404,192",
    D: ["397,91", "398,128"],
    M: ["378,91", "377,128"],
    I: ["388,106","387,117"],
    B: "354,93",
    Pa: "381,131",
    position: "388,71"
  },
  24: {
    coors: "406,10,438,192",
    D: ["431,92", "433,136"],
    M: ["409,92", "409,136"],
    O: "420,136",
    B: "420,92",
    Pa: "421,154",
    position: "419,71"
  },
  25: {
    coors: "439,10,469,192",
    D: ["465,92", "465,133"],
    M: ["442,92", "441,134"],
    O: "453,136",
    B: "453,92",
    Pa: "453,154",
    position: "453,73"
  },
  26: {
    coors: "472,9,516,191",
    D: ["514,92", "513,138"],
    M: ["475,92", "478,136"],
    O: "494,137",
    B: "494,88",
    Pa: "494,157",
    position: "495,70"
  },
  27: {
    coors: "518,10,562,191",
    D: ["557,92", "556,138"],
    M: ["523,93", "524,136"],
    O: "538,139",
    B: "540,92",
    Pa: "539,161",
    position: "543,75"
  },
  28: {
    coors: "564,9,609,191",
    D: ["603,92", "603,134"],
    M: ["569,93", "569,134"],
    O: "586,134",
    B: "585,92",
    Pa: "585,160",
    position: "585,76"
  },
  48: {
    coors: "2,196,46,374",
    D: ["5,255", "6,291"],
    M: ["40,255", "40,291"],
    O: "23,256",
    B: "23,295",
    Li: "23,237",
    position: "23,313"
  },
  47: {
    coors: "48,196,92,375",
    D: ["50,254", "50,293"],
    M: ["88,254", "88,293"],
    O: "69,255",
    B: "67,293",
    Li: "68,237",
    position: "69,314"
  },
  46: {
    coors: "94,195,139,376",
    D: ["96,255", "96,295"],
    M: ["135,254", "135,293"],
    O: "117,255",
    B: "117,293",
    Li: "115,237",
    position: "116,315"
  },
  45: {
    coors: "140,195,174,377",
    D: ["142,251", "144,295"],
    M: ["169,254", "167,293"],
    O: "156,251",
    B: "156,295",
    Li: "156,237",
    position: "156,313"
  },
  44: {
    coors: "176,195,205,376",
    D: ["176,259", "179,293"],
    M: ["202,256", "202,293"],
    O: "190,255",
    B: "189,295",
    Li: "191,237",
    position: "189,314"
  },
  43: {
    coors: "206,196,242,378",
    D: ["213,254", "213,297"],
    M: ["231,256", "230,297"],
    I: ["224,270", "222,283"],
    B: "223,296",
    Li: "222,255",
    position: "223,318"
  },
  42: {
    coors: "243,196,273,378",
    D: ["250,254", "249,295"],
    M: ["262,256", "261,295"],
    I: ["255,273", "255,282"],
    B: "255,294",
    Li: "255,257",
    position: "255,316"
  },
  41: {
    coors: "274,195,304,379",
    D: ["282,259", "282,294"],
    M: ["297,259", "295,295"],
    I: ["288,273", "288,282"],
    B: "289,297",
    Li: "289,260",
    position: "289,316"
  },
  31: {
    coors: "305,196,336,378",
    D: ["328,259", "327,294"],
    M: ["313,259", "314,294"],
    I: ["319,272", "318,280"],
    B: "320,294",
    Li: "319,257",
    position: "321,317"
  },
  32: {
    coors: "338,197,369,380",
    D: ["360,259", "360,294"],
    M: ["346,259", "348,295"],
    I: ["354,272", "354,281"],
    B: "354,296",
    Li: "353,256",
    position: "355,316"
  },
  33: {
    coors: "370,196,404,378",
    D: ["397,255", "396,295"],
    M: ["378,257", "378,296"],
    I: ["386,271", "386,282"],
    B: "387,298",
    Li: "386,257",
    position: "387,319"
  },
  34: {
    coors: "406,197,436,380",
    D: ["431,254", "431,296"],
    M: ["408,254", "409,296"],
    O: "420,255",
    B: "420,298",
    Li: "419,236",
    position: "419,312"
  },
  35: {
    coors: "438,198,470,380",
    D: ["467,254", "465,296"],
    M: ["441,255", "444,296"],
    O: "452,252",
    B: "454,299",
    Li: "453,236",
    position: "454,315"
  },
  36: {
    coors: "472,200,520,378",
    D: ["513,255", "514,296"],
    M: ["475,255", "476,296"],
    O: "493,256",
    B: "494,299",
    Li: "493,236",
    position: "494,316"
  },
  37: {
    coors: "519,198,564,380",
    D: ["560,254", "559,296"],
    M: ["522,256", "524,296"],
    O: "541,256",
    B: "542,299",
    Li: "541,237",
    position: "543,315"
  },
  38: {
    coors: "565,197,610,382",
    D: ["605,254", "603,293"],
    M: ["569,255", "569,295"],
    O: "586,257",
    B: "587,296",
    Li: "587,238",
    position: "588,315"
  }
}

const primaryTeethMapper = {
   55: {
    coors: "133,48,171,190",
    D: ["141,96", "142,129"],
    M: ["166,96", "166,129"],
    O: "154,128",
    B: "153,96",
    Pa: "152,145",
    position: "154,89"
  },
  54: {
    coors: "173,48,206,190",
    D: ["178,101", "179,128"],
    M: ["198,101", "196,127"],
    O: "188,127",
    B: "189,99",
    Pa: "188,141",
    position: "189,87"
  },
  53: {
    coors: "209,47,238,190",
    D: ["212,96", "212,125"],
    M: ["230,96", "229,121"],
    I: ["220,106", "220,115"],
    B: "220,96",
    Pa: "222,136",
    position: "221,78"
  },
  52: {
    coors: "239,46,270,190",
    D: ["247,99", "248,119"],
    M: ["262,99", "260,121"],
    I: ["254,106", "254,115"],
    B: "254,99",
    Pa: "254,119",
    position: "254,89"
  },
  51: {
    coors: "272,47,304,189",
    D: ["279,100", "279,121"],
    M: ["297,98", "296,121"],
    I: ["289,106", "288,115"],
    B: "288,98",
    Pa: "288,124",
    position: "289,86"
  },
  61: {
    coors: "306,46,338,188",
    D: ["329,98", "328,122"],
    M: ["311,97", "313,122"],
    I: ["319,107", "319,116"],
    B: "319,98",
    Pa: "320,125",
    position: "319,87"
  },
  62: {
    coors: "339,46,369,188",
    D: ["361,97", "261,121"],
    M: ["347,97", "349,121"],
    I: ["352,155", "353,116"],
    B: "353,98",
    Pa: "354,122",
    position: "354,88"
  },
  63: {
    coors: "371,46,406,188",
    D: ["369,95", "369,123"],
    M: ["378,95", "382,125"],
    I: ["389,104", "387,115"],
    B: "387,95",
    Pa: "387,125",
    position: "388,86"
  },
  64: {
    coors: "408,45,439,187",
    D: ["428,101", "429,127"],
    M: ["410,99", "412,126"],
    O: "419,127",
    B: "418,99",
    Pa: "420,140",
    position: "419,89"
  },
  65: {
    coors: "440,48,472,188",
    D: ["465,99", "464,128"],
    M: ["444,99", "444,129"],
    O: "453,129",
    B: "454,96",
    Pa: "455,145",
    position: "454,89"
  },
  85: {
    coors: "133,195,171,346",
    D: ["142,260", "142,289"],
    M: ["166,261", "166,288"],
    O: "156,262",
    B: "155,293",
    Li: "154,250",
    position: "154,299"
  },
  84: {
    coors: "172,195,208,347",
    D: ["178,263", "179,287"],
    M: ["199,265", "198,287"],
    O: "188,263",
    B: "188,290",
    Li: "189,252",
    position: "188,295"
  },
  83: {
    coors: "209,195,239,346",
    D: ["215,262", "214,289"],
    M: ["228,262", "228,289"],
    I: ["220,271", "222,280"],
    B: "222,290",
    Li: "221,263",
    position: "221,300"
  },
  82: {
    coors: "241,195,270,346",
    D: ["249,264", "250,287"],
    M: ["260,264", "261,289"],
    I: ["255,272", "255,280"],
    B: "255,289",
    Li: "255,263",
    position: "255,299"
  },
  81: {
    coors: "272,195,302,348",
    D: ["283,267", "282,286"],
    M: ["294,267", "292,287"],
    I: ["288,272", "288,279"],
    B: "287,287",
    Li: "287,265",
    position: "288,296"
  },
  71: {
    coors: "304,194,336,350",
    D: ["326,267", "326,286"],
    M: ["314,267", "316,286"],
    I: ["319,272", "320,281"],
    B: "320,287",
    Li: "320,265",
    position: "321,297"
  },
  72: {
    coors: "338,195,371,348",
    D: ["360,264", "359,287"],
    M: ["348,265", "348,288"],
    I: ["353,273", "353,280"],
    B: "353,289",
    Li: "353,264",
    position: "353,300"
  },
  73: {
    coors: "372,194,402,348",
    D: ["394,264", "394,289"],
    M: ["381,264", "381,289"],
    I: ["389,271", "386,280"],
    B: "386,289",
    Li: "387,262",
    position: "386,302"
  },
  74: {
    coors: "404,194,436,348",
    D: ["431,261", "430,287"],
    M: ["410,264", "412,287"],
    O: "419,263",
    B: "421,290",
    Li: "421,251",
    position: "420,298"
  },
  75: {
    coors: "437,194,472,347",
    D: ["466,260", "466,290"],
    M: ["442,263", "442,290"],
    O: "455,261",
    B: "455,291",
    Li: "454,251",
    position: "455,299"
  }
}


export default function TeethChart({className = '', page = 1, lastPage = 1, goToPage = (p)=>{}, selections = {}, onSelect = (t)=>{},
disabled = false, usePrimaryTeeth = false
}) {
  const teethMapper = usePrimaryTeeth ? primaryTeethMapper:permamentTeethMapper

  let array = []
  Object.keys(teethMapper).forEach(key => array.push({
    teeth: key,
    ...teethMapper[key]
  }))

  const activePoints = useMemo(()=>{
    let dots = []
    let cross = []
    let circle = []

    for (let selection of selections) {
      const {teeth, teethSide, isCross, isSelected} = selection

      for (let tooth of teeth) {
        if (!teethMapper[tooth]) continue
        
        if (teethSide?.length) {
          for (let side of teethSide) {
            if (teethMapper[tooth][side]) {
              if (Array.isArray(teethMapper[tooth][side])) {
                dots.push(...teethMapper[tooth][side])
              } else {
                dots.push(teethMapper[tooth][side])
              }
            }
          }
        } else if (isSelected) {
          circle.push(teethMapper[tooth].position)
        } else if (isCross) {
          cross.push(teethMapper[tooth].position)
        }
      }
    }

    return {
      dots,
      cross,
      circle
    }
  }, [selections])

  return (
    <>
    <div style={{width: 611, maxWidth: '100%', position: 'relative'}}>
      <img src={usePrimaryTeeth?primaryTeethImage:teethImage} usemap="#workmap"  style={{width: '100%'}} />
      { activePoints.circle.map((item, index)=>{
          const [left, top] = item.split(',')

          return <div key={item} className="circle" style={{ borderRadius: '50%', border: '2px solid red', position: 'absolute',
          left: Number(left*100/611) + '%', top: Number(top*100/386) + '%',
            transform: 'translate(-50%, -50%)'}} />
          })
      }
      { activePoints.dots.map((item, index)=>{
          const [left, top] = item.split(',')

          return <div key={item} className="dot" style={{borderRadius: '50%', background: 'red', position: 'absolute',
          left: Number(left*100/611) + '%', top: Number(top*100/386) + '%',
            transform: 'translate(-50%, -50%)'}} />
          })
      }
      { activePoints.cross.map((item, index)=>{
          const [left, top] = item.split(',')

          return <div key={item} className="cross" style={{ position: 'absolute',
          left: Number(left*100/611) + '%', top: Number(top*100/386) + '%',
            transform: 'translate(-50%, -50%)'}} />
          })
      }
    </div>
    { !disabled &&
    <map name="workmap">
      { array.map((item, index) => {
        return <area shape="rect" key={index} coords={item.coors} alt="Computer" onClick={(e)=>{
          e.preventDefault()
          onSelect(item.teeth)
        }} href="#" />
      })
      }
    </map>
    }
    </>
  );
}
